import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class SubstanceScreeningCollectionSite extends AbstractModel {
  @autoserialize
  providerClinicId: number;

  @autoserialize
  name: string;

  @autoserialize
  address1: string;

  @autoserialize
  address2: string;

  @autoserialize
  city: string;

  @autoserialize
  state: string;

  @autoserialize
  zipCode: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  faxNumber: string;
}
